import { MEDIAS } from '@/common/js/constants'
import { IMAGE_TYPES_STR_VAL as IMAGE_TYPES } from '@/views/material/uploading/consts.js'

export const REJECT_REASONS = [
  { label: '混剪内容不搭', value: 1 },
  { label: '字幕文案错误/违规', value: 2 },
  { label: '画面错误', value: 3 },
  { label: '字幕重叠', value: 4 },
  { label: '背景音乐问题', value: 5 },
  { label: '尺寸包边问题', value: 6 }
]
export const SORT_TYPE_LIST = [
  { id: 1, name: '上传时间降序排列', orderColumn: 'create_time', orderSort: 'desc' },
  { id: 2, name: '上传时间升序排列', orderColumn: 'create_time', orderSort: 'asc' },
  { id: 3, name: '素材大小降序排列', orderColumn: 'size', orderSort: 'desc' },
  { id: 4, name: '素材大小升序排列', orderColumn: 'size', orderSort: 'asc' }
]

export const REMIX_VIDEO_STAGE_LIST = [
  { label: '待审核', value: IMAGE_TYPES.REMIX_AUDIT_PRE },
  { label: '待入库', value: IMAGE_TYPES.REMIX_AUDIT_PASS },
  { label: '审核被拒', value: IMAGE_TYPES.REMIX_AUDIT_DENY }
]

export const UPLOAD_TYPE = {
  BATCH_AD: 1,
  MATERIAL_UPLOAD: 3
}
export const UPLOAD_TYPE_LIST = [
  { label: '批量计划', value: UPLOAD_TYPE.BATCH_AD },
  { label: '素材上传', value: UPLOAD_TYPE.MATERIAL_UPLOAD }
]

export const BATCH_COMMANDS_ENUM = {
  EDIT: 1,
  REMOVE: 2,
  LIMIT: 3,
  REDO: 4
}

export const SEARCH_TYPE = {
  ALL: '',
  SCRIPT: 'script',
  ID: 'id',
  NAME: 'name',
  AI: 'ai',
  VIDEO: 'video'
}
export const SEARCH_LABEL_LIST = [
  { label: '全部', value: '' },
  { label: '脚本', value: 'script' },
  { label: '素材ID', value: 'id' },
  { label: '素材名称', value: 'name' },
  { label: 'AI关键词', value: 'ai' },
  { label: '视频描述', value: 'video' }
]

export const BINARY_MEDIA = {
  TOUTIAO: 1,
  GDT: 2,
  KUAISHOU: 4,
  BAIDU: 8
}

export const BINARY_MEDIA_LIST = [
  { label: '巨量引擎', value: BINARY_MEDIA.TOUTIAO, imagePrefix: 'jl' },
  { label: '腾讯', value: BINARY_MEDIA.GDT, imagePrefix: 'gdt' },
  { label: '磁力引擎', value: BINARY_MEDIA.KUAISHOU, imagePrefix: 'ks' },
  { label: '百度信息流', value: BINARY_MEDIA.BAIDU, imagePrefix: 'bd' }
]

export const LIB_FILTER_VALUE = {
  CONSUMED: 10000,
  UN_CONSUMED: 10001,
  USED: 10002,
  UN_USED: 10003
}

export const HAS_AMOUNT_TYPES = [
  {
    label: '有消耗',
    value: LIB_FILTER_VALUE.CONSUMED,
    children: BINARY_MEDIA_LIST
  },
  {
    label: '无消耗',
    value: LIB_FILTER_VALUE.UN_CONSUMED,
    children: BINARY_MEDIA_LIST
  }
]

export const HAS_PLAN_TYPES = [
  {
    label: '已使用',
    value: LIB_FILTER_VALUE.USED,
    children: BINARY_MEDIA_LIST
  },
  {
    label: '未使用',
    value: LIB_FILTER_VALUE.UN_USED,
    children: BINARY_MEDIA_LIST
  }
]

const REJECTION_LIST = [
  {
    label: '未拒审',
    value: 0
  },
  {
    label: '大于等于1次',
    value: 1
  },
  {
    label: '大于等于2次',
    value: 2
  },
  {
    label: '大于等于3次',
    value: 3
  },
  {
    label: '大于等于5次',
    value: 5
  },
  {
    label: '大于等于10次',
    value: 10
  },
  {
    label: '大于等于20次',
    value: 20
  },
  {
    label: '大于等于30次',
    value: 30
  },
  {
    label: '大于等于50次',
    value: 50
  }
]

export const MEDIA_REJECTIONS = [
  { label: '巨量引擎拒审', value: MEDIAS.TOUTIAO, children: REJECTION_LIST },
  { label: '腾讯拒审', value: MEDIAS.GDT, children: REJECTION_LIST },
  { label: '磁力引擎拒审', value: MEDIAS.KUAISHOU, children: REJECTION_LIST }
  // { label: '百度信息流', value: 8 }
]
